import React, { useContext, useState } from 'react';
import API from '../api/axios';
import { Navigate, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import Footer from '../components/Footer';
import '../style/Register.css';
import { GoogleLogin } from '@react-oauth/google';

export default function Register() {
    const [form, setForm] = useState({ name: '', email: '', password: '' });
    const { user, login } = useContext(AuthContext);
    const { darkMode } = useTheme();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await API.post('/auth/register', form);
            alert('✅ Registered successfully!');
            navigate('/login');
        } catch (err) {
            alert('❌ Registration failed.');
            console.error(err);
        }
    };


    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            //  JWT token by Google 
            const res = await API.post('/auth/google', {
                token: credentialResponse.credential
            });

            // Backend verify karke apna token aur user bhejta hai
            localStorage.setItem('token', res.data.token);
            login(res.data.user);
            navigate('/');
        } catch (err) {
            console.error("Google Login Error", err);
            alert(err.response?.data?.error || '❌ Google Login failed. Please try again!');
        }
    };

    const handleGoogleError = () => {
        alert('❌ Google Sign-In was unsuccessful. Try again!');
    };
    // by - rajan 

    if (user) return <Navigate to="/" />;

    return (
        <div className={`register-page ${darkMode ? 'dark' : 'light'}`}>
            <div className="register-card">
                <h2>🔐 Create Your Account</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Full Name"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        required
                    />
                    <input
                        type="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        required
                    />
                    <button type="submit">Register</button>
                </form>


                {/* google sign in button */}
                <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}>
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={handleGoogleError}
                        theme={darkMode ? 'filled_black' : 'outline'}
                        shape="pill"
                    />
                </div>
                {/* by rajan */}

                <p>
                    Already registered? <Link to="/login">Login here</Link>
                </p>
            </div>
            {/* footer spacing from content */}
            <div style={{ marginTop: '5rem' }}>
                <Footer />
            </div>
        </div>
    );
}
